// eslint-disable-next-line
export default (value: any = undefined): boolean =>
  value === undefined || value === null
